<template>
    <div class="rebate_intro right_auth">
        <div class="top">
            <p class="left chain">推荐注册链接：<span id="clip">http://www.sd235.net/reset/register.html?vcode={{vcode}}</span></p>
            <button ref="copy" data-clipboard-target="#clip" @click="copy">复制链接</button>
            <img v-if="wxCode" :src="API.PRE + wxCode" alt="二维码">
        </div>
        <p class="title">推荐返利活动</p>
        <ul class="content">
            <li>1.深度配音为促进老客户带动新客户的业务增长，即日起开展暂推荐返利活动！</li>
            <li>2.只要老客户使用平台专用的推荐注册链接，引导新客户注册，并产生业务，即可获取返利！</li>
            <li>3.多推荐多得，一级推荐和二级推荐都有返利，即A推荐B,B再推荐C,A也可从C的业务获取返利！</li>
            <li>4.具体规则细则见下。</li>
        </ul>
        <p class="title">推荐返利规则</p>
        <ul class="content">
            <li>1. 必须访问推荐人的推荐链接或二维码，并注册成功，才能参与返利。</li>
            <li>2. 推荐人是老用户推荐其他人成功交易，并且单笔订单利润大于零，即可获得被推荐人一定比例返利。</li>
            <li>3. 返利大于100元时可提现，提现请联系客服。</li>
        </ul>
        <p class="flag">注明：本规则会定期更新，本规则解释权归深度配音所有</p>
    </div>
</template>
<script>
    import Clipboard from 'clipboard'
    import { mapState, mapActions , mapGetters} from 'vuex'

    let API = util.apis();
    export default{
        data(){
            return {
                vcode:'',
                wxCode:'',
                API: API
            }
        },
        computed:{
            ...mapState({
                userInfo : state => state.common.userInfo,
            })
        },
        methods: {
            // 复制成功提示
            copy(){
                util.confirm.success('已复制到剪切板！')
            }
        },
        mounted(){
            let a = this.$refs.copy;
            new Clipboard(a);
            this.$store.dispatch('getUserInfo').then(res=>{
               this.vcode = res.data.recommendCode;
            });

            let param = {
              scene: `refCode=${this.userInfo.recommendCode||''}`,
              page: 'pages/home/home'
            }
            util.kAjax(API.GETSMALLPROCEDURE, param, res => {
                this.wxCode = res.data;
            })
        }
    }
</script>



// WEBPACK FOOTER //
// RebateIntro.vue?5ea03936